var t;
(function(e) {
  e.templateCardClicked = "template_card_clicked", e.templateBookmarkButtonClicked = "template_bookmark_button_clicked", e.templateModalViewed = "template_detail_modal_viewed", e.templateCreateClicked = "template_create_clicked", e.templateLoadingScreenViewed = "template_loading_screen_viewed", e.googleSSOButtonClicked = "google_sso_button_clicked", e.templateShareButtonClicked = "template_share_button_clicked", e.mediaSlideshowItemSelected = "media_slideshow_item_selected", e.mediaSlideshowCarouselArrowClicked = "media_slideshow_carousel_arrow_clicked";
})(t || (t = {}));
var l = "web_analytics.tracking.user_interaction.UserInteractionEvent", _ = "entry-point-method", a = "entry-point-location", d = "zap_template", i = "templates_home";
export {
  i as ENTRY_POINT_LOCATION,
  a as ENTRY_POINT_LOCATION_QUERY_PARAM,
  d as ENTRY_POINT_METHOD,
  _ as ENTRY_POINT_METHOD_QUERY_PARAM,
  l as UserInteractionEvent,
  t as UserInteractionEventName
};
//# sourceMappingURL=trackingTypes.es.js.map
